// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import { capitalizeFLetter, fetchApiData } from '../../../fnc.js'
import $ from 'jquery'
import Select from 'react-select';

const refConst = require("../../../constants.js").v
refConst.styleList.container = (provided) => ({
	...provided,
	width: "80%",
	minWidth: "250px"
})

export default function ModalPmaStores(props){

	const initialState = {
		refreshView: 0,
		modalSearchTerm: "",
		pmaStoreList: [],
		version: "0.1.0",
		selectedColor: "#007bff", // Default color
		selectedStoreForEdit: null
	}

	const refModalAssignedTo = useRef(null);
	const refStoreTitle = useRef(null);
	const refOurStoreId = useRef(null);
	const refStoreQuantity = useRef(null);
	const refStoreUrl = useRef(null);
	const refStorePrcDown = useRef(null);
	const [modalSearchTerm, setModalSearchTerm] = useState(initialState.modalSearchTerm);
	const [pmaStoreList, setPmaStoreList] = useState(initialState.pmaStoreList);
	const [version, setVersion] = useState(initialState.version);
	const [selectedColor, setSelectedColor] = useState(initialState.selectedColor);
	const [selectedStoreForEdit, setSelectedStoreForEdit] = useState(initialState.selectedStoreForEdit);
	const [refreshView, setRefreshView] = useState(initialState.refreshView);

	let refsList = [
		refStoreTitle,
		refOurStoreId,
		refStoreQuantity,
		refStoreUrl,
		refStorePrcDown
	]

	useEffect(() => {
		$('[data-toggle]').tooltip({
			placement: "bottom"
		}).tooltip('update')
	})

	useEffect(() => {
		if(refModalAssignedTo.current){
			modalAssignedTo(refModalAssignedTo.current)
		}
	}, [refModalAssignedTo?.current, modalSearchTerm, pmaStoreList, refConst.stores, refOurStoreId.current, selectedColor, selectedStoreForEdit, refConst.stores])

	useEffect(() => {
		if(!selectedStoreForEdit){
			resetRefs()
		}
		console.info("Sfsdfsf", selectedStoreForEdit);
		setSelectedColor(selectedStoreForEdit?.color)
		let listOfStoreAssociated = null

		// Change the format of the old value
		if(selectedStoreForEdit?.id_store_associated_ids){
			if(typeof selectedStoreForEdit?.id_store_associated_ids == "string"){
				listOfStoreAssociated = selectedStoreForEdit?.id_store_associated_ids.split(",").map(s => {
					return parseInt(s)
				})
			}else if(Array.isArray(selectedStoreForEdit?.id_store_associated_ids)){
				listOfStoreAssociated = selectedStoreForEdit?.id_store_associated_ids.map(s => {
					return parseInt(s)
				})
			}else{

				alert(typeof listOfStoreAssociated)
			}
			// Make the list of store associated for our Select
			let listOfStoreAssociatedForSelect = listOfStoreAssociated? listOfStoreAssociated.map(s => {
				return {
					value: s,
					label: refConst.stores.find(ss => ss.id == s)?.name
				}
			}) : []
			console.info('dsdfdsdfdsfsd1111', refConst.stores);
			console.info('dsdfdsdfdsfsd2222', listOfStoreAssociatedForSelect);
			if(listOfStoreAssociatedForSelect.length > 0 && !selectedStoreForEdit?.id_store_associated_ids_select){
				setSelectedStoreForEdit(prev => ({
					...prev,
					id_store_associated_ids_select: listOfStoreAssociatedForSelect
				}))
			}
			setRefreshView(prev => prev + 1)
		}

		if(selectedStoreForEdit?.title){
			refStoreTitle.current.value = selectedStoreForEdit?.title
		}
		if(refStoreQuantity.current){
			refStoreQuantity.current.checked = selectedStoreForEdit?.require_pack_qty
		}
	}, [selectedStoreForEdit])

	let findEmailFromId = (id) => {
		let acc = props.accounts.find((v) => v.id === id);
		if(acc){
			return acc.data_firebase?.email.split("@")[0];
		}
		return "-"
	}

	let init = () => {
		resetPage()
		resetRefs()
		fetchStores()
		modalAssignedTo()
	}

	let handleSubmit = (e) => {
		e.preventDefault()

		let storeTitle = refStoreTitle.current.value
		let ourStoreId = refOurStoreId.current?.value
		let storeQuantity = refStoreQuantity.current
		let storeUrl = refStoreUrl.current.value
		let storePrcDown = refStorePrcDown.current.value

		console.info("refOurStoreId", refOurStoreId.current);
		console.info("storeTitle", storeTitle);

		if((storeTitle == "" && ourStoreId == "") || storeUrl == ""){
			props.info({error: "Please indicate a store and a url"})
			return
		}

		if(ourStoreId){
			storeTitle = refConst.stores.find(s => s.id == ourStoreId).name
		}

		let data = {
			'title': storeTitle,
			'url': storeUrl,
			'require_pack_qty': storeQuantity.checked,
			'id_store_associated_ids': selectedStoreForEdit?.id_store_associated_ids_select?.map(s => {
				return parseInt(s.value)
			}).join(","),
			'color': selectedColor,
			'prc_down': storePrcDown
		}
		if(selectedStoreForEdit?.id){
			data.id = selectedStoreForEdit.id
		}
		console.info(
			"selectedStoreForEdit222", selectedStoreForEdit
		);
		if(selectedStoreForEdit?.lookout_by){
			data.lookout_by = selectedStoreForEdit.lookout_by.map(s => {
				return parseInt(s.value)
			}).join(",")
		}else{
			data.lookout_by = null
		}

		console.info("OUTPUT", data);

		fetchApiData("eio", "setPMAStore", {
			'data': JSON.stringify(data)
		}, null, (r) => {
			console.log("setPMAStore", r)
			if(r.res.processed || r.res.updated || r.res.ignored){
				fetchStores()
				setSelectedStoreForEdit(null)
			}
		})
	}

	let removeStore = (storeId) => {
		if (window.confirm('Are you sure you want to remove this store?')) {
			fetchApiData("eio", "deletePMAStore", {
				id: storeId
			}, null, (r) => {
				console.log("deletePMAStore", r)
				if(r.errorInfo.length > 0) {
					if(r.errorInfo[0].code == 1451) {
						props.info({error: "This store has PMA attached to it, you have detach each pma first."})
					}else{
						props.info({error: "Failed to remove store"})
					}
				}else{
					if(r.deleted) {
						fetchStores()
					} else {
						props.info({error: "Failed to remove store"})
					}
				}
			})
		}
	}

	const fetchStores = () => {
		fetchApiData("eio", "getPMAStores", {
		}, null, (r) => {
			console.log("getPMAStores", r)

			r.data.forEach(s => {
				if(typeof s.lookout_by == "string")
					s.lookout_by = s.lookout_by && refConst.stores? refConst.stores.filter(ss => {
						return s.lookout_by.split(",").includes(ss.id.toString())
					}).map(ss => {
						return {
							value: ss.id,
							label: ss.name
						}
					}) : null
			})
			setPmaStoreList(r.data? r.data : [])
		})
	}

	let modalAssignedTo = () => {
		console.info("pmaStoreList", pmaStoreList);

		props.modal({
			show: true,
			title: "Competitor Management",
			html: () => {

				console.info("selectedStoreForEditselectedStoreForEdit", selectedStoreForEdit);

				let hasOutStore = selectedStoreForEdit?.id_store_associated? true : false;


				return <div>
					<form
						className="mb-3"
						style={{backgroundColor: '#f0f0f0', padding: '15px', borderRadius: '5px'}}
						onSubmit={handleSubmit}
					>
						{
							selectedStoreForEdit?.id?
								<div>
									<h5>Edit Store <button className="btn btn-sm btn-outline-danger ml-2" onClick={() => {
										setSelectedStoreForEdit(null)
									}}>
										Close Editor
										<i className="bi bi-close"></i>
									</button></h5>
								</div>
								:
								<div>
									<h5>Store input to add</h5>
								</div>
						}
						<div className="d-flex justify-content-between align-items-center">

							<div className="form-group mr-1">
								<div className="border rounded mt-2 p-2">
									<label className="mt-0">
										Store name
									</label>
									<input 
										type="text" 
										className="form-control"
										placeholder="ex: ebay.com"
										ref={refStoreTitle}
										defaultValue={hasOutStore? "" : selectedStoreForEdit?.title}
									/>
								<div>
								<div className="form-group mt-2">
									<label>
										Stores lookout for competitivness
										<i className="bi bi-info-circle-fill text-info ml-1" data-toggle="tooltip" title="Select which stores need to have a strict competitivness if possible, mainly for eio & hausoftools"></i>
									</label>
									<Select
										isClearable
										styles={refConst.styleList}
										// className="w-50"
										onChange={(selectedOption) => {
											setSelectedStoreForEdit(prev => ({...prev, lookout_by: selectedOption}))
										}}
										options={refConst.stores.map((s) => {
											return {
												value: s.id,
												label: s.name
											}
										}
										)}
										// value={ o.last.name in dataMapping? [{value: dataMapping[o.last.name], label: dataMapping[o.last.name]}] : (o.shopify_id_associated? [{value: o.shopify_id_associated, label: o.shopify_id_associated}] : null) }
										value={selectedStoreForEdit?.lookout_by ?? null}
										placeholder={"Select store"}
										isSearchable={true}
										isMulti={true}
									/>
								</div>
								</div>
							</div>
							</div>
							<div className="form-group mr-1 text-center">
								<label>Allow QTY Box</label>
								<input
									type="checkbox"
									className="form-control m-auto" 
									style={{width: '20px', height: '20px'}}
									ref={refStoreQuantity}
									onChange={(e) => {
										setSelectedStoreForEdit(prev => ({...prev, require_pack_qty: e.target.checked}))
									}}
									value={selectedStoreForEdit?.require_pack_qty ?? ""}
								/>
								<label className="mt-2">Store Color</label>
								<div className="d-flex align-items-center">
									<input
										type="color"
										className="form-control mr-2 m-auto"
										style={{width: '50px', height: '38px', padding: '2px'}}
										onChange={(e) => {
											setSelectedColor(e.target.value)
											setSelectedStoreForEdit(prev => ({...prev, color: e.target.value}))
										}}
										value={selectedStoreForEdit?.color ?? ""}
									/>
									<span>{selectedColor}</span>
								</div>
							</div>
							<div className="d-flex flex-column">
								<div className="form-group">
									<label>
										Store URL
										<i className="bi bi-info-circle-fill text-info ml-1" data-toggle="tooltip" title="The URL to reach this store, ex: ebay.com"></i>
									</label>
									<input 
										type="text" 
										className="form-control"
										placeholder="ex: https://www.ebay.com/store"
										ref={refStoreUrl}
										value={selectedStoreForEdit?.url ?? ""}
										onChange={(e) => {
											const inputUrl = e.target.value;
											let domainOnly = inputUrl;
											try {
												const urlObj = new URL(inputUrl.includes('://') ? inputUrl : 'http://' + inputUrl);
												domainOnly = urlObj.hostname;
											} catch (err) {
												// fallback: try to extract domain with regex if not a valid URL
												const match = inputUrl.match(/^(?:https?:\/\/)?([^/]+)/i);
												if (match) domainOnly = match[1];
											}
											setSelectedStoreForEdit(prev => ({...prev, url: domainOnly}))
										}}
									/>
								</div>
								<div className="form-group mt-2">
									<label>Prc down for competitivness</label>
									<input 
										type="text" 
										className="form-control"
										placeholder="ex: 10"
										ref={refStorePrcDown}
										value={selectedStoreForEdit?.prc_down ?? ""}
										onChange={(e) => {
											setSelectedStoreForEdit(prev => ({...prev, prc_down: e.target.value}))
										}}
									/>
								</div>
							</div>
							<button type="submit" className="btn btn-primary ml-2">
								<i className="bi bi-save"></i> Save
							</button>
						</div>
						<div>
							<label>Is this store a marketplace where we also have an account ? if so which one ?</label>
							<Select
								isClearable
								styles={refConst.styleList}
								onChange={(selectedOption) => {
									console.info("Selected option:", selectedOption);
									setSelectedStoreForEdit(prev => ({
										...prev, 
										id_store_associated_ids_select: selectedOption
									}))
								}}
								options={refConst.stores.map((s) => {
									return {
										value: s.id,
										label: s.name
									}
								}
								)}
								value={selectedStoreForEdit?.id_store_associated_ids_select ?? null}
								placeholder={"Select store"}
								isSearchable={true}
								isMulti={true}
							/>
							{/* <select className="form-control" ref={refOurStoreId} value={hasOutStore? selectedStoreForEdit?.id_store_associated : ""} onChange={(e) => {
								setSelectedStoreForEdit({...selectedStoreForEdit, id_store_associated: e.target.value})
							}}>
								<option value="">-</option>
								{
									refConst.stores?.map(s => {
										if(s.id_marketplace)
											return <option key={`ourStoreList_${s.id}-${s.name}`} value={s.id}>{s.name}</option>
									})
								}
							</select> */}
						</div>
					</form>
					<div className="mb-3">
						<input
							type="text"
							className="form-control"
							placeholder="Search users..."
							value={modalSearchTerm}
							onChange={(e) => setModalSearchTerm(e.target.value)}
						/>
					</div>
					<div className="list-group" style={{maxHeight: "300px", overflowY: "auto"}} >
						{
							pmaStoreList && pmaStoreList.length > 0?
								pmaStoreList.filter(s => {
									if(modalSearchTerm.length > 0){
										return s.title.toLowerCase().includes(modalSearchTerm.toLowerCase());
									}
									return true
								})
								.map((s) => {
									console.info("sssss", s);
									let storeAssociated = refConst.stores.find(s => s.id == s.id_store_associated)
									console.info("storeAssociated", storeAssociated);
								return (
									<div 
										key={`storeinfo_${s.id}-${s.title}`}
										type="button" 
										className={"list-group-item list-group-item-action d-flex justify-content-between align-items-center" + (selectedStoreForEdit?.id == s.id? " active" : "")}
										onClick={() => {

											setSelectedStoreForEdit(s)
										}}
									>
										<div className="d-flex align-items-center justify-content-between w-100">
											{s.title}
											<div className="text-right">
												<span className="badge badge-primary badge-pill ml-2">{s.require_pack_qty? "QTY" : "NO QTY"}</span>
												<span className="badge badge-secondary badge-pill ml-2">{s.url}</span>
												<span className="badge badge-secondary badge-pill ml-2">{s.prc_down}%</span>
												<span className="badge badge-secondary badge-pill ml-2" data-toggle="tooltip" title={s.lookout_by? s.lookout_by?.map(ss => ss.label).join(", ") : "No lookout"}>{s.lookout_by? Object.values(s.lookout_by)?.length : 0}</span>
												{s.id_store_associated? <span className="badge badge-pill ml-2">Attached to: {refConst.stores.find(ss => ss.id == s.id_store_associated)?.name}</span> : ""}
												<span className="badge badge-pill ml-2" style={{
													backgroundColor: s.color,
													width: '20px',
													height: '20px',
													borderRadius: '50%',
													display: 'inline-block',
													verticalAlign: 'middle'
												}}></span>
											</div>
										</div>
										<button 
											className="btn btn-sm btn-outline-danger ml-2"
											onClick={(e) => {
												e.stopPropagation();
												removeStore(s.id);
											}}
											title="Remove store"
										>
											<i className="bi bi-trash"></i>
										</button>
									</div>
								)
							}) : "-"
						}
					</div>
				</div>
			}
			, ok: null
			, exit: (popup, close) => {
				refModalAssignedTo.current = false
				close()
			}
			, return: {
				title: "Close",
				fnc: (popup, close) => {
					refModalAssignedTo.current = false
					close()
				}
			}
		})
	}

	let resetPage = () => {
		for (const key in initialState) {
			if (initialState.hasOwnProperty(key)) {
				// const element = initialState[key];
				let val = JSON.parse(JSON.stringify(initialState[key]))
				console.info('Eval result', eval("set" + capitalizeFLetter(key))(val));
			}
		}
	}

	let resetRefs = () => {
		// We set each refsList
		refsList.forEach(ref => {
			if(ref.current && "value" in ref.current){
				ref.current.value = ""
			}else if(ref.current && "checked" in ref.current){
				ref.current.checked = false
			}else if(ref.current && "selected" in ref.current){	
				ref.current.selected = false
			}
		})
	}

	console.info("selectedStoreForEdit" , selectedStoreForEdit);

	return (
		<button className={"pointer " + ("className" in props? props.className : ' list-group-item list-group-item-action p-2 text-center')} onClick={() => {
			refModalAssignedTo.current = true
			init()
		}}>
			{
				props.title
			}
		</button>
	);
}